import { render, staticRenderFns } from "./unlockList.vue?vue&type=template&id=2516888c&scoped=true"
import script from "./unlockList.vue?vue&type=script&lang=js"
export * from "./unlockList.vue?vue&type=script&lang=js"
import style0 from "./unlockList.vue?vue&type=style&index=0&id=2516888c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2516888c",
  null
  
)

export default component.exports